import { getDevCenterDataStore } from "../app/store";
import { getConfigurationReducerData, getIsWidget, getPartnerName, getPartnerFullName  } from "../lhs/reducers/configuration-reducer";

function replaceSpace(input) {
    if (input != undefined) {
        return input.toLowerCase().replace(/\s+/g, '-');
    }
}

function removeSpace(input) {
    if (input != undefined)
        return input.toLowerCase().replace(/[\s]/g, '');
}


function replaceSpecialChars(input) {
        if (input != undefined) {
            return input.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
        }
}

function removeSpecialChars(input) {
        if (input != undefined) {
            return input.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, '');
        }
}

function replaceUnderscoreWithSpace(input) {
        if (input != undefined) {
            return input.replace(/_+/g, ' ');
        }
    }

    function replaceHypenWithSpace(input) {
        if (input != undefined) {
            return input.replace(/-+/g, ' ');
        }
    }



    function replaceSpaceWithUnderScore(input) {
        if (input != undefined) {
            return input.replace(/ /g, "_");
        }
    }


    function prettyPrintJson(json) {
        return JSON ? JSON.stringify(json, null, '  ') : 'your browser doesnt support JSON so cant pretty print';
    }



    function objectLength(object) {
        return Object.keys(object).length;
    }



    function styleFilter(input) {
        if (input == "post") {
            return "restVerb-post";
        } else if (input == "get") {
            return "restVerb-get";
        } else if (input == "put") {
            return "restVerb-put";
        } else if (input == "delete") {
            return "restVerb-delete";
        }
    }

    function titleCase(input) {
        input = input || '';
        return input.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };



    function capitalizeFirstLetter(input) {
        if (input != undefined) {
            return input.charAt(0).toUpperCase() + input.substr(1);
        }
    }


    function idAllSmallCase(input) {
        if (input != undefined) {
            return input.toLowerCase();
        }
    }


     function urlParameters(input) {
        var arr = [];
         arr.forEach(input, function(v) {
            if (v.in === 'path' || v.in === 'query') {
                arr.push(v);
            }
        });
        return arr;
    }



     function reverseArray(items) {
        return items.slice().reverse();
    };

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

function replaceValidEncodedCharacters(val) {
    var chars = '" %<>[]^`{|}\\'
    chars = chars.split('');
    chars.forEach(function(c) {
        val = val.replaceAll(encodeURI(c), c);
    });
    return val;
}

// Toggle content visiblity
function ToggleContentVisibility(content) {
    if (content.style.display === "none") {
        content.style.display = "block";
    } else {
        content.style.display = "none";
    }
}
// Replace stop words
function replaceStopWords(fileName) {
    if (fileName != undefined) {
        fileName = fileName.replace(" an ", " ").replace("-an-", "-");
        fileName = fileName.replace(" An ", " ").replace("-An-", "-");
        fileName = fileName.replace(" a ", " ").replace("-a-", "-");
        fileName = fileName.replace(" A ", " ").replace("-A-", "-");
        fileName = fileName.replace(" the ", " ").replace("-the-", "-");
        fileName = fileName.replace(" The ", " ").replace("-The-", "-");
        return fileName;
    }
}

function nameToCamelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return word.toUpperCase();
    }).replace(/\s+/g, ' ');
}

// Converts underscore separated words into camel case
String.prototype.underscoreToCamel = function() {
    //if no underscore return with first character as capital
    if (this.indexOf("_") == -1) {
        return this.charAt(0).toUpperCase() + this.slice(1);
    }

    return this.charAt(0).toUpperCase() +
        this.slice(1).replace(/\_([A-Za-z0-9])/g,
            function($1, $2) { return $2.charAt(0).toUpperCase() });
};

//Converts camel case to underscore (lowercase)
//Sample test cases: Secure_File_Share, TMS, secure_File_Share
String.prototype.toUnderscore = function() {
    //if all caps, just return lowercase
    if (this.toUpperCase() == this) {
        return this.toLowerCase();
    }

    return this.charAt(0).toLowerCase() +
        this.slice(1).replace(/([A-Z])([a-z0-9]+)/g, function($1) { return "_" + $1.toLowerCase(); });
}

function pascalCase(str) {
    var firstPart = str.charAt(0).toLowerCase();
    var firstLowerCaseIndex = 1;
    //Loop till we find a lower case letter
    while (firstLowerCaseIndex < str.length && str[firstLowerCaseIndex].toLowerCase() != str[firstLowerCaseIndex]) {
        firstPart = firstPart + str.charAt(firstLowerCaseIndex).toLowerCase();
        firstLowerCaseIndex++;
    }

    return firstPart + str.slice(firstLowerCaseIndex);
}


function copyStringToClipboard(str) {
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    el.setSelectionRange(0, 99999);
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
}



function getCredCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}



function displayNonSupportedInternetExplorerVersionMessage() {
    var element = document.getElementsByClassName("ie9msg");
    for (var i = 0; i < element.length; i++) {
        element[i].style.display = "show";
    }
}

// function to check if a string has JSON structure, different from JSON parsability
function hasJsonStructure(str) {
    if (typeof str !== 'string') return false;
    try {
        const result = JSON.parse(str);
        const type = Object.prototype.toString.call(result);
        return type === '[object Object]' ||
            type === '[object Array]';
    } catch (err) {
        return false;
    }
}

// Used in jstree select node and deselect node event
function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }

    return true;
}

// This is method to load url in new tab
function loadUrlInNewTab(url)
{
    if(url != undefined && url != null)
    {
        window.open(url, '_blank');
    }
}


function enableCopyMessage(id)
{
    var element = document.getElementById(id);
    if(element != null)
    {
        element.style.display = "block";
    }
}

function disableCopyMessage(id)
{
    var element = document.getElementById(id);
    if(element != null)
    {
        element.style.display = "none";
    }
}

function addSpacesBeforeCaps(inputStr){
    var newStr = "";
    newStr = newStr + inputStr.charAt(0);
    for(var i = 1; i < inputStr.length; i++){
        var c = inputStr.charAt(i);
        if(c >= 'A' && c <= 'Z' && inputStr.charAt(i-1)!=' '){
            newStr = newStr + ' ';
        }
        newStr = newStr + c;
    }
    return newStr;
}

function setWindowLocationHash(newHash){
    if(getConfigurationReducerData){
        if(!getIsWidget()){
            window.location.hash = newHash;
        }
    }
    else{
        window.location.hash = newHash;
    }
    
}

//retreive Product mapping JSON from product-map element which is added through AEM
function getProductMapJson(partnerName) {
    var productMapJsonElement = document.getElementById("product-map");
    if (null != productMapJsonElement) {
        var productCatalogJson = productMapJsonElement.getAttribute("data-json");
        if (productCatalogJson != "undefined") {
            productCatalogJson = JSON.parse(decodeURIComponent(productCatalogJson));
            if (Object.entries(productCatalogJson).length !== 0) {
                if(partnerName == "vas") {
                    partnerName = "voap"; // Remove this condition once we migrate all config from voap to vas
                }
                var hostkey = Object.keys(productCatalogJson).filter(key => key.includes(partnerName));
                productCatalogJson = productCatalogJson[hostkey];
                return productCatalogJson;
            }  
        }
    }
    return {};
}

function getMappingJsonFromID(elementID) {
    var miniTilesJsonElement = document.getElementById(elementID);
    if(miniTilesJsonElement !== null) {
        var miniTilesJson = miniTilesJsonElement.getAttribute("data-json");
        if(miniTilesJson !== null) {
            miniTilesJson = JSON.parse(decodeURIComponent(miniTilesJson));
            return miniTilesJson;
        }
    }
    return {};
}

// returns flag indicating whether to use the font family from EPC API
function useFontStyleFromEPC() {
    return document.body.classList.contains('fontStyle');
}

// Replace cybersource references with partner name
function replaceOrUpdateBrandName(inputStr) {
    var partnerFullName = getPartnerFullName().length > 0 ? getPartnerFullName() : 'Cybersource';

    if (inputStr && (inputStr.includes(' Cybersource ') || inputStr.includes(' CyberSource '))) {
        inputStr = inputStr.replaceAll(/Cybersource/ig, partnerFullName);
    }

    return inputStr;
}

function updateLinksInDescription(inputStr, partnerName) {
    inputStr = inputStr.replaceAll('/docs/cybs/', `/docs/${partnerName}/`);
    inputStr = inputStr.replaceAll('https://developer.cybersource.com', '');

    return inputStr;
}

// Retrieve processors list
function getProcessorsList() {
    var processorsList = [];
    var processorsListElement = document.getElementById("processors-list");
    if (null != processorsListElement) {
        var processorsList = processorsListElement.getAttribute("data-processors-list");
        if (processorsList != "undefined") {
            processorsList = JSON.parse(decodeURIComponent(processorsList)); 
        }
    }
    return processorsList;
}

function getPartnerConfigVal(key) {
    var partnerConfigVal = '';
    var partnerConfigJson = getMappingJsonFromID("partner-config");
    if (partnerConfigJson) {
        var partnerDetailsJson = partnerConfigJson["partner-details"];
        if(partnerDetailsJson) {
            partnerConfigVal = partnerDetailsJson[key];
        }
    }
    return partnerConfigVal;
}

// Download a file from given URL
function downloadFileFromLink(filename, url) {
    const a = document.createElement('a');
    a.id = 'specDownloadLink';
    a.download = filename;
    a.href = url;
    document.body.appendChild(a);
    setTimeout(() => a.click(), 500);
    setTimeout(() => document.body.removeChild(a), 1000);
}

export default replaceSpace;
export {replaceSpace,removeSpace,replaceSpecialChars,removeSpecialChars,replaceUnderscoreWithSpace,replaceHypenWithSpace,
    replaceSpaceWithUnderScore,prettyPrintJson,objectLength,styleFilter,titleCase,capitalizeFirstLetter,nameToCamelCase,
    replaceStopWords,pascalCase,idAllSmallCase,urlParameters,reverseArray,replaceValidEncodedCharacters,
    ToggleContentVisibility,isJson,hasJsonStructure,displayNonSupportedInternetExplorerVersionMessage,
    getCredCookie,copyStringToClipboard,loadUrlInNewTab,addSpacesBeforeCaps, setWindowLocationHash, getProductMapJson,
    useFontStyleFromEPC, replaceOrUpdateBrandName, getMappingJsonFromID, getProcessorsList, getPartnerConfigVal,
    downloadFileFromLink, updateLinksInDescription};

